app.factory('statementModel', ['$rootScope', 'baseModel', 'statementService', 'authInterceptor', 'config', '$http', '$sce',
    function($rootScope, baseModel, statementService, authInterceptor, config, $http, $sce) {

        function StatementModel() {
            
            this.getDataPage = function(criteria) {
                statementService.getDataPage(criteria).then(
                    function (dataPage) {
                        $rootScope.$broadcast(Event.STATEMENT.GET_DATA_PAGE.SUCCESS, dataPage);
                    },
                    function(error) {
                        $rootScope.$broadcast(Event.STATEMENT.GET_DATA_PAGE.ERROR, error);
                    }
                )
            };

            this.getById = function(id) {
                statementService.getById(id).then(
                    function (statement) {
                        $rootScope.$broadcast(Event.STATEMENT.GET_BY_ID.SUCCESS, statement);
                    },
                    function(error) {
                        $rootScope.$broadcast(Event.STATEMENT.GET_BY_ID.ERROR, error);
                    }
                )
            };

            this.save = function(statement) {
                statementService.save(statement).then(
                    function (savedStatement) {
                        $rootScope.$broadcast(Event.STATEMENT.SAVE.SUCCESS, savedStatement);
                    },
                    function(error) {
                        $rootScope.$broadcast(Event.STATEMENT.SAVE.ERROR, error);
                    }
                )
            };

            this.update = function(statement) {
                statementService.update(statement).then(
                    function (updatedStatement) {
                        $rootScope.$broadcast(Event.STATEMENT.UPDATE.SUCCESS, updatedStatement);
                    },
                    function(error) {
                        $rootScope.$broadcast(Event.STATEMENT.UPDATE.ERROR, error);
                    }
                )
            };

            this.delete = function(statement) {
                statementService.delete(statement).then(
                    function (response) {
                        $rootScope.$broadcast(Event.STATEMENT.DELETE.SUCCESS, response);
                    },
                    function(error) {
                        $rootScope.$broadcast(Event.STATEMENT.DELETE.ERROR, error);
                    }
                )
            };

            this.downloadPDF = function(statement) {
                var fileLocation = config.API_URL + '/statements/' + statement.id  + '/pdf/download';
                window.open(fileLocation, '_blank');
            };

            this.downloadPDFToFill = function(patient) {
                var fileLocation = config.API_URL + '/statements/patient/' + patient.id  + '/pdfToFill';

                $http({
                    url: fileLocation,
                    method: "GET",
                    headers: {
                        'Content-type': 'application/json',
                        'X-AUTH-TOKEN': authInterceptor.token
                    },
                    responseType: 'arraybuffer'
                }).success(function (data, status, headers, config) {
                    var file = new Blob([data], {type: 'application/pdf'});
                    var fileURL = URL.createObjectURL(file);
                    var link = $sce.trustAsResourceUrl(fileURL);
                    window.open(link, '_blank');
                    window.focus();
                }).error(function (data, status, headers, config) {

                });
            };


        }

        return new StatementModel();
    }
]);
